import { useAlert } from '../../../../context/Alert.context';
import { useEffect, useState } from 'react';
import { API } from '../../../../api/api';
import { URLS } from '../../../../api/urls';
import { PriceData, UpdatePriceDto } from './types';

export const useEditServiceInfoPricesModal = ({selectedServiceInfoId}: {selectedServiceInfoId: string}) => {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<UpdatePriceDto[]>([]);

  useEffect(() => {
    setLoading(true)
    API.get(`${URLS.SERVICE}/getServices?serviceInfoId=${selectedServiceInfoId}`)
      .then((res) => {
        setData(res.data);
      })
      .catch((e) => showAlert({ message: e.message, severity: 'error' }))
      .finally(() => setLoading(false));
  }, []);

  const onSave = async (serviceId: string, values: PriceData) => {
    try {
      const result =await API.put(`${URLS.SERVICE}/admin/updatePrice`, {oldPrice: +values.oldPrice, price: +values.price, serviceId})
      const {data} = result;
      updateData(serviceId, data);
      showAlert({ message:`Price was updated`, severity: 'success' })
    } catch (e: any) {
      showAlert({ message: e.message, severity: 'error' })
    }
  }

  const updateData = (serviceId: string, result: PriceData) => {
    setData((prev) =>
      prev.map((item) =>
        item.serviceId === serviceId
          ? { ...item, oldPrice: +result.price, price: +result.price }
          : item
      )
    );
  };

  return {
    hasData: !!data && data.length > 0,
    data,
    loading,
    onSave
  }
}